import { cn } from '@/lib/utils/cn';
import { HTMLAttributes, ReactNode } from 'react';

export interface Props extends HTMLAttributes<HTMLDivElement> {
    footer?: ReactNode;
    header?: ReactNode;
    title?: string;
    animate?: boolean;
}

export const Panel = ({ children, footer, className, header, animate = true, ...rest }: Props) => {
    return (
        <div className={cn('flex h-full max-h-[inherit] w-full flex-col', className)} {...rest}>
            {header && <div className='flex w-full flex-none'>{header}</div>}
            <div className='scrollbar flex w-full flex-1 flex-col overflow-y-auto'>
                <div
                    className={cn(
                        'w-full space-y-2 p-4 duration-300',
                        animate && 'animate-in fade-in fill-mode-backwards slide-in-from-bottom-[50px] ease-out-circ'
                    )}
                >
                    {children}
                </div>
            </div>
            {footer && <div className='flex flex-none flex-row justify-between'>{footer}</div>}
        </div>
    );
};
